import { FabricChannel } from '@atlaskit/analytics-listeners/types';

export const editorAnalyticsChannel = FabricChannel.editor;
